import { useState } from "react";
import { useSnackbar } from "notistack";
import { useQueryClient } from "react-query";
import { createBot } from "../api/v1/bots";
import { botsQuery } from "./useBots";
import ReactGA from "react-ga4";

const i18n = {
  error: "Unable to create bot at this time.",
};

export const useBotCreate = () => {
  const [isFetching, setFetching] = useState(false);
  const [isFetched, setFetched] = useState(false);
  const [isError, setError] = useState(false);
  const [data, setData] = useState(null);
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  const call = (payload) => {
    setFetching(true);

    createBot(payload)
      .then((result) => {
        queryClient.invalidateQueries(botsQuery).then(() => {
          // Record GA
          ReactGA.event({
            category: "bot",
            action: "new bot",
          });
          setFetching(false);
          setFetched(true);
          setData(result);
        });
      })
      .catch((err) => {
        const errorMsg =
          err && err.response.data.error
            ? err.response.data.error[0]
            : i18n.error;
        enqueueSnackbar(errorMsg, { variant: "error" });
        setFetching(false);
        setError(true);
      });
  };
  return { call, data, isFetched, isFetching, isError };
};
